<app-loading-overlay [isLoading]="uploading">
  <div class="profile-modal">
    <!-- Sidebar -->
    <div class="profile-sidebar">
      <div class="profile-sidebar__header">
        <h2 class="profile-sidebar__title">{{ "PROFILE" | translate }}</h2>
        <button class="profile-sidebar__close" bv-button variant="ghost" iconOnly (click)="dialogRef.close()">
          <bv-icon name="close"></bv-icon>
        </button>
      </div>
      <nav class="profile-sidebar__nav">
        <button
          class="profile-sidebar__nav-item"
          [class.profile-sidebar__nav-item--active]="profTab === 0"
          (click)="selectTab(0)"
          >
          <bv-icon name="person" class="profile-sidebar__nav-icon"></bv-icon>
          <span>{{ "PROFILE" | translate }}</span>
        </button>
        <button
          class="profile-sidebar__nav-item"
          [class.profile-sidebar__nav-item--active]="profTab === 1"
          (click)="selectTab(1)"
          >
          <bv-icon name="language" class="profile-sidebar__nav-icon"></bv-icon>
          <span>{{ "LANGUAGE" | translate }}</span>
        </button>
        <button
          class="profile-sidebar__nav-item"
          [class.profile-sidebar__nav-item--active]="profTab === 2"
          (click)="selectTab(2)"
          >
          <bv-icon name="credit_card" class="profile-sidebar__nav-icon"></bv-icon>
          <span>{{ "SUBSCRIPTION" | translate }}</span>
        </button>
        @if (profServ.latestProfile?.stripeID) {
          <button
            class="profile-sidebar__nav-item"
            [class.profile-sidebar__nav-item--active]="profTab === 3"
            (click)="selectTab(3)"
            >
            <bv-icon name="payment" class="profile-sidebar__nav-icon"></bv-icon>
            <span>{{ "PAYMENT_METHODS" | translate }}</span>
          </button>
        }
        <button
          class="profile-sidebar__nav-item"
          [class.profile-sidebar__nav-item--active]="profTab === 4"
          (click)="selectTab(4)"
          >
          <bv-icon name="tune" class="profile-sidebar__nav-icon"></bv-icon>
          <span>{{ "PREFERENCES" | translate }}</span>
        </button>
        <button
          id="btn_profile_danger_zone"
          class="profile-sidebar__nav-item profile-sidebar__nav-item--danger"
          [class.profile-sidebar__nav-item--active]="profTab === 5"
          (click)="selectTab(5)"
          >
          <bv-icon name="warning" class="profile-sidebar__nav-icon"></bv-icon>
          <span>{{ "DANGER_ZONE" | translate }}</span>
        </button>
      </nav>
    </div>

    <!-- Content -->
    <div class="profile-content">
      <div class="profile-content__header">
        @if (profTab === 0) {
          <h3 class="profile-content__title">{{ "PROFILE" | translate }}</h3>
        }
        @if (profTab === 1) {
          <h3 class="profile-content__title">{{ "LANGUAGE" | translate }}</h3>
        }
        @if (profTab === 2) {
          <h3 class="profile-content__title">{{ "SUBSCRIPTION" | translate }}</h3>
        }
        @if (profTab === 3) {
          <h3 class="profile-content__title">{{ "PAYMENT_METHODS" | translate }}</h3>
        }
        @if (profTab === 4) {
          <h3 class="profile-content__title">{{ "PREFERENCES" | translate }}</h3>
        }
        @if (profTab === 5) {
          <h3 class="profile-content__title">{{ "DANGER_ZONE" | translate }}</h3>
        }
        <button bv-button variant="ghost" iconOnly (click)="dialogRef.close()" class="profile-content__close">
          <bv-icon name="close"></bv-icon>
        </button>
      </div>

      <div class="profile-content__body">
        <!-- Profile Tab -->
        @if (profTab === 0) {
          <div>
            <form #profForm="ngForm">
              <div class="profile-section">
                <div class="profile-section__label">ID</div>
                <div class="profile-section__value profile-section__uid">{{ profServ.uid }}</div>
              </div>
              <div class="profile-separator"></div>
              <div class="profile-section">
                <div class="profile-section__label">
                  <span>{{ "DISPLAY_NAME" | translate }}</span>
                  <bv-icon
                    name="info"
                    size="sm"
                    class="profile-label__info"
                    tabindex="0"
                    [bvTooltip]="'SHARED_WITH_CLUBS_INFO' | translate"
                    bvTooltipPosition="after"
                  ></bv-icon>
                </div>
                <div class="profile-section__value">
                  <input
                    bv-input
                    type="text"
                    name="profDispName"
                    [(ngModel)]="displayName"
                    required
                    (keyup.enter)="saveProfile()"
                    />
                </div>
              </div>
              <div class="profile-separator"></div>
              <div class="profile-section">
                <div class="profile-section__label">
                  <span>{{ "FIRST_NAME" | translate }}</span>
                  <bv-icon
                    name="info"
                    size="sm"
                    class="profile-label__info"
                    tabindex="0"
                    [bvTooltip]="'SHARED_WITH_CLUBS_INFO' | translate"
                    bvTooltipPosition="after"
                  ></bv-icon>
                </div>
                <div class="profile-section__value">
                  <input
                    bv-input
                    type="text"
                    name="profFirstName"
                    [(ngModel)]="firstName"
                    (keyup.enter)="saveProfile()"
                    />
                </div>
              </div>
              <div class="profile-separator"></div>
              <div class="profile-section">
                <div class="profile-section__label">
                  <span>{{ "LAST_NAME" | translate }}</span>
                  <bv-icon
                    name="info"
                    size="sm"
                    class="profile-label__info"
                    tabindex="0"
                    [bvTooltip]="'SHARED_WITH_CLUBS_INFO' | translate"
                    bvTooltipPosition="after"
                  ></bv-icon>
                </div>
                <div class="profile-section__value">
                  <input
                    bv-input
                    type="text"
                    name="profLastName"
                    [(ngModel)]="lastName"
                    (keyup.enter)="saveProfile()"
                    />
                </div>
              </div>
              <div class="profile-separator"></div>
              @if (this.provider == 'password') {
                <div class="profile-section">
                  <div class="profile-section__label">{{ "EMAIL" | translate }}</div>
                  <div class="profile-section__value">
                    <div class="flex items-center gap-2">
                      <span>{{ email }}</span>
                      <button bv-button variant="ghost" iconOnly (click)="openResetEmailModal()" class="shrink-0">
                        <bv-icon name="edit"></bv-icon>
                      </button>
                    </div>
                  </div>
                </div>
              }
              @if (this.provider == 'password') {
                <div class="profile-separator"></div>
              }
              <div class="profile-section profile-section--col profile-section--center">
                <div class="profile-section__label">{{ "PROFILE_IMAGE" | translate }}</div>
                <div class="profile-section__value">
                  <app-photo-picker
                    [prevImg]="imgURL"
                    (onCrop)="setCroppedImg($event)"
                    [editable]="imgType == 'custom' || provider == 'password'"
                    [showDelete]="!!(imgType == 'custom' && imgURL && imgURL !== '/assets/img/anonymous.png')"
                    [fallbackName]="profServ.latestProfile?.dispName"
                    [fallbackSize]="160"
                    (onDelete)="openDeletePhotoConfirm()"
                  ></app-photo-picker>
                  @if (provider != 'password') {
                    <bv-radio-group
                      (ngModelChange)="profImageSelect($event)"
                      class="image-type-group"
                      [(ngModel)]="imgType"
                      name="image-type"
                      >
                      @if (provider == 'facebook') {
                        <bv-radio value="facebook">
                          {{ "FACEBOOK_PROFILE_IMAGE" | translate }}
                        </bv-radio>
                      }
                      @if (provider == 'google') {
                        <bv-radio value="google">
                          {{ "GOOGLE_PROFILE_IMAGE" | translate }}
                        </bv-radio>
                      }
                      <bv-radio value="custom">
                        {{ "CUSTOM_PROFILE_IMAGE" | translate }}
                      </bv-radio>
                    </bv-radio-group>
                  }
                </div>
              </div>
            </form>
          </div>
        }

        <!-- Language Tab -->
        @if (profTab === 1) {
          <div>
            <form #langForm="ngForm">
              <div class="profile-section">
                <div class="profile-section__label">{{ "LANGUAGE" | translate }}</div>
                <div class="profile-section__value">
                  <select bv-input [(ngModel)]="language" name="language">
                    @for (language of this.transConfigServ.latestLanguages; track language.code) {
                      <option
                        [ngValue]="language.code"
                      >{{ language.localizedName }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="profile-section">
                <div class="profile-section__label">{{ "REGIONAL_FORMAT" | translate }}</div>
                <div class="profile-section__value">
                  <select bv-input [(ngModel)]="region" name="region">
                    <option [ngValue]="''">{{ "REGION_AUTO_DETECT" | translate }}{{ autoRegionHint }}</option>
                    @for (r of regionOptions; track r.code) {
                      <option [ngValue]="r.code">{{ r.label }}</option>
                    }
                  </select>
                </div>
              </div>
            </form>
          </div>
        }

        <!-- Subscription Tab -->
        @if (profTab === 2) {
          <div>
            <app-loading-overlay [isLoading]="profServ.sub_processing">
              <div class="profile-section">
                <div class="profile-section__label" translate="PLAN"></div>
                <div class="profile-section__value">
                  {{ getActivePlanName() }}
                  @if (profServ.latestSubscription && !profServ.latestSubscription?.code) {
                    <span
                    >({{ "FREE" | translate }})</span>
                  }
                </div>
              </div>
              <div class="profile-separator"></div>
              <!-- Empty state for free / Kitchen Table users: icon + minimal upsell teaser -->
              @if (!profServ.latestSubscription || !profServ.latestSubscription?.code) {
                <div
                  class="profile-empty-state"
                  >
                  <img src="/assets/icons/upgrade.svg" alt="" class="profile-empty-state__icon" />
                  <div class="profile-empty-state__text" translate="KITCHEN_TABLE_UPGRADE_TEASE"></div>
                </div>
              }
              @if (profServ.latestSubscription && profServ.latestSubscription?.code) {
                <div class="profile-section">
                  <div class="profile-section__label" translate="PRICE"></div>
                  <div class="profile-section__value">{{ getSubscriptionPrice() }}</div>
                </div>
                <div class="profile-separator"></div>
                <div class="profile-section">
                  <div class="profile-section__label" translate="SUBSCRIPTION_START"></div>
                  <div class="profile-section__value">
                    {{ profServ.latestSubscription?.created * 1000 | date : "yyyy-MM-dd" }}
                  </div>
                </div>
                <div class="profile-separator"></div>
                @if (!profServ.latestSubscription?.cancel_at_period_end) {
                  <div class="profile-section">
                    <div class="profile-section__label" translate="NEXT_PAYMENT"></div>
                    <div class="profile-section__value">
                      {{ profServ.latestSubscription?.current_period_end * 1000 | date : "yyyy-MM-dd" }}
                    </div>
                  </div>
                }
                @if (profServ.latestSubscription?.cancel_at_period_end) {
                  <div class="profile-section">
                    <div class="profile-section__label" translate="SUBSCRIPTION_END"></div>
                    <div class="profile-section__value">
                      {{ profServ.latestSubscription?.current_period_end * 1000 | date : "yyyy-MM-dd" }}
                    </div>
                  </div>
                }
                <div class="profile-separator"></div>
                @if (profServ.latestSubscription?.cancel_at_period_end) {
                  <div class="tc-bv-orange" style="padding: 12px 0; font-size: 14px;" translate="SUBSCRIPTION_CANCELLED"></div>
                }
                <div class="profile-section">
                  <div class="profile-section__label" translate="STATUS"></div>
                  <div class="profile-section__value">
                    {{ profServ.latestSubscription?.status | translate }}
                  </div>
                </div>
                <div class="profile-separator"></div>
              }
              @if (storageUsed; as used) {
                <div class="profile-section">
                  <div class="profile-section__label" translate="STORAGE_USED"></div>
                  <div class="profile-section__value">{{ used.value | number: used.digits }} {{ used.unit }}</div>
                </div>
                <div class="profile-separator"></div>
              }
              @if (profServ.latestProfile?.stripeAcctBalance) {
                <div class="profile-section">
                  <div class="profile-section__label" translate="ACCOUNT_BALANCE"></div>
                  <div class="profile-section__value">
                    {{ getAcctBalance() | currency : profServ.latestProfile?.currency : "symbol-narrow" }}
                  </div>
                </div>
              }
              @if (profServ.latestProfile?.amount_due) {
                <div class="profile-section">
                  <div class="profile-section__label tc-warn" translate="past_due"></div>
                  <div class="profile-section__value">
                    {{ getAmountDue() | currency : profServ.latestProfile?.currency : "symbol-narrow" }}
                  </div>
                </div>
              }
            </app-loading-overlay>
          </div>
        }

        <!-- Payment Methods Tab -->
        @if (profTab === 3) {
          <div>
            <app-loading-overlay [isLoading]="profServ.sub_processing">
              <!-- Header -->
              <div class="pm-header">
                <div>
                  <div class="pm-subtitle">{{ "PAYMENT_METHODS_DESC" | translate }}</div>
                </div>
                <button class="pm-add-btn" (click)="mountCard()">
                  <bv-icon name="add"></bv-icon>
                  <span>{{ "ADD_PAYMENT_METHOD" | translate }}</span>
                </button>
              </div>
              <!-- Add card form (toggled) -->
              @if (showAddCard) {
                <div class="pm-add-form">
                  <div
                    class="pm-card-input"
                    id="add-card-element"
                    [ngClass]="{ 'error-field': subServ.cardError }"
                  ></div>
                  <button bv-button variant="primary" (click)="addCard()">
                    {{ "ADD_CARD" | translate }}
                  </button>
                  @if (subServ.cardError) {
                    <div class="tc-red-500 text-sm mt-1">{{ subServ.cardError }}</div>
                  }
                </div>
              }
              <!-- Card list -->
              <div class="pm-cards">
                @for (card of profServ.latestProfile?.stripeCards | objArr; track card.id) {
                  <div
                    class="pm-card"
                    [class.pm-card--default]="profServ.latestProfile?.stripeDefaultSource == card.id"
                    >
                    <div class="pm-card__icon">
                      @if (subServ.paymentIcon(card.brand) != 'none') {
                        <img
                          class="pm-card__brand-img"
                          [src]="subServ.paymentIcon(card.brand)"
                          [alt]="card.brand"
                          />
                      }
                      @if (subServ.paymentIcon(card.brand) == 'none') {
                        <bv-icon name="credit_card" class="tc-bv-orange"></bv-icon>
                      }
                    </div>
                    <div class="pm-card__info">
                      <div class="pm-card__number">
                        {{ card.brand }} &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; {{ card.last4 }}
                        @if (profServ.latestProfile?.stripeDefaultSource == card.id) {
                          <span
                            class="pm-card__default-badge"
                          >{{ "DEFAULT" | translate }}</span>
                        }
                      </div>
                      <div class="pm-card__expiry">
                        {{ "EXPIRES" | translate }} {{ card.exp_month }}/{{ card.exp_year }}
                      </div>
                    </div>
                    <div class="pm-card__actions">
                      @if (profServ.latestProfile?.stripeDefaultSource != card.id) {
                        <button
                          bv-button variant="ghost" iconOnly
                          (click)="setDefaultCard(card)"
                          >
                          <bv-icon name="check_circle_outline" class="pm-card__action-icon"></bv-icon>
                        </button>
                      }
                      <button bv-button variant="ghost" iconOnly (click)="deleteCard(card)">
                        <bv-icon name="delete_outline" class="pm-card__action-icon"></bv-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
              <!-- Empty state -->
              @if (!(profServ.latestProfile?.stripeCards | objArr)?.length) {
                <div
                  class="pm-empty"
                  >
                  {{ "NO_PAYMENT_METHODS" | translate }}
                </div>
              }
            </app-loading-overlay>
          </div>
        }

        <!-- Preferences Tab -->
        @if (profTab === 4) {
          <div>
            <h4 class="prefs-section-title">{{ "PRINT_TICKETS" | translate }}</h4>
            <div class="prefs-row">
              <div class="prefs-row__label">{{ "PAPER_SIZE_TITLE" | translate }}</div>
              <bv-radio-group
                [ngModel]="paperSize.current"
                (ngModelChange)="paperSize.setSize($event)"
                >
                <bv-radio value="80mm">{{ "PAPER_SIZE_80MM" | translate }}</bv-radio>
                <bv-radio value="58mm">{{ "PAPER_SIZE_58MM" | translate }}</bv-radio>
              </bv-radio-group>
            </div>
            <h4 class="prefs-section-title">{{ "NEWSLETTER" | translate }}</h4>
            <div class="prefs-row">
              <bv-switch
                [ngModel]="profServ.newsletterAccepted"
                (ngModelChange)="profServ.setNewsletterAccepted($event)"
              >{{ "NEWSLETTER_PREF_LABEL" | translate }}</bv-switch>
            </div>
          </div>
        }

        <!-- Danger Zone Tab -->
        @if (profTab === 5) {
          <div class="danger-zone">
            <div class="danger-zone__title">{{ "DELETE_ACCOUNT" | translate }}</div>
            <p class="danger-zone__description">{{ "DELETE_ACCOUNT_DESCRIPTION" | translate }}</p>
            <button
              id="btn_delete_account"
              bv-button
              variant="danger"
              (click)="openDeleteAccount()"
            >
              {{ "DELETE_ACCOUNT" | translate }}
            </button>
          </div>
        }
      </div>

      <!-- Actions -->
      <div class="profile-content__actions">
        @if (profTab < 2) {
          <button
            bv-button variant="primary"
            (click)="saveProfile()" [disabled]="profForm?.form?.valid === false || uploading"
          >{{ "CONFIRM" | translate }}</button>
        }
        @if (profTab == 2) {
          <button
            bv-button variant="primary"
            (click)="changePlan()"
          >{{ "COMPARE_PLANS" | translate }}</button>
        }
        @if (profServ.latestSubscription?.cancel_at_period_end && profTab == 2) {
          <button
            bv-button variant="primary"
            (click)="subServ.reactivateSubscription()"
          >{{ "REACTIVATE" | translate }}</button>
        }
        @if (profServ.latestSubscription && !profServ.latestSubscription?.cancel_at_period_end && profTab == 2) {
          <button
            bv-button variant="ghost" class="tc-error"
            (click)="subServ.cancelSubscription()"
          >{{ "CANCEL_SUBSCRIPTION" | translate }}</button>
        }
        <button
          bv-button variant="primary" (click)="payInvoice()"
          [hidden]="!profServ.latestProfile?.subscription_card_declined || !profServ.latestProfile?.amount_due || profTab != 2"
        >{{ "PAY_INVOICE" | translate }}</button>
        @if (profTab < 2) {
          <button
            bv-button variant="ghost"
            (click)="dialogRef.close()"
          >{{ "CANCEL" | translate }}</button>
        }
      </div>
    </div>
  </div>
</app-loading-overlay>
